// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : REMOVED UNUSED TYPES
// MODIFIED DATE: 26-09-2025

const repaymentCollectionReportTypes = {
	/************* FETCH REPAYMENT COLLECTION REPORT START *********************** */
	FETCH_POST_REPAYMENT_COLLECTION_START: 'fetch_post_repayment_collection_start',
	FETCH_POST_REPAYMENT_COLLECTION_SUCCESS: 'fetch_post_repayment_collection_success',
	FETCH_POST_REPAYMENT_COLLECTION_FAILURE: 'fetch_post_repayment_collection_failure',
	FETCH_POST_REPAYMENT_COLLECTION_RESPONSE_CHANGED:
		'fetch_post_repayment_collection_response_changed',
	FETCH_POST_REPAYMENT_COLLECTION_RESET: 'fetch_post_repayment_collection_reset',
	/************* FETCH REPAYMENT COLLECTION REPORT END *********************** */
};
export default repaymentCollectionReportTypes;
